import { ChildModel, ModelBase } from 'store/model-base';
import { OrderTransaction } from './order-transaction';

export class OrderCollection extends ModelBase {
    public static storeName: string = 'orderCollection';

    public orderTransactions: OrderTransaction[];

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'orderTransactions',
            model: OrderTransaction
        }];
    }
}
